export default [
  'Argentina',
  'Australia',
  'Plurinational State of Bolivia',
  'Brazil',
  'Canada',
  'Chile',
  'Denmark',
  "People's Republic of China",
  'Colombia',
  'Democratic Republic of The Congo',
  'Ecuador',
  'Estonia',
  'European Union',
  'Finland',
  'France',
  'Germany',
  'Greenland',
  'India',
  'Indonesia',
  'Italy',
  'Japan',
  'Korea',
  'Mexico',
  'New Zealand',
  'Norway',
  'Peru',
  'Philippines',
  'Poland',
  'South Africa',
  'Spain',
  'Sweden',
  /*'Turkiye',*/
  'Ukraine',
  'United Kingdom',
  'United States',
];
